import React from 'react'
import PropTypes from 'prop-types'

const AiSvg = ({ width = 24, height = 24, fill = '#000', classNames }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width} height={height}
            viewBox="0 0 512.000000 512.000000"
            className={classNames}
        >

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={fill} stroke="none">
                <path d="M1248 4593 c-9 -10 -61 -102 -117 -205 l-102 -186 -187 -102 c-192
-104 -222 -126 -222 -165 0 -39 30 -61 222 -165 l187 -102 102 -186 c56 -103
109 -195 117 -204 16 -19 67 -24 92 -9 8 6 62 97 120 203 l106 193 195 107
c203 111 226 131 213 183 -7 28 -17 34 -269 173 l-140 77 -105 193 c-58 106
-112 197 -120 202 -24 16 -76 11 -92 -7z"/>
                <path d="M3027 4318 c-17 -16 -72 -144 -177 -413 -84 -214 -172 -428 -196
-475 -84 -163 -203 -294 -362 -398 -88 -57 -157 -87 -665 -287 -202 -79 -302
-124 -312 -138 -20 -29 -19 -70 3 -96 11 -14 158 -77 419 -180 221 -87 429
-173 463 -190 197 -100 354 -256 454 -451 24 -47 112 -260 196 -475 174 -447
183 -461 264 -424 32 15 26 2 206 459 157 401 200 493 274 588 90 117 237 241
354 301 37 19 380 156 775 311 98 38 110 46 123 76 12 29 12 39 0 68 -12 29
-25 38 -93 64 -284 110 -768 304 -809 325 -170 87 -341 256 -433 429 -22 40
-108 246 -191 458 -84 212 -158 399 -166 416 -26 54 -86 69 -127 32z"/>
                <path d="M1103 1732 c-7 -4 -48 -73 -91 -152 l-79 -145 -152 -84 c-156 -87
-179 -110 -154 -150 5 -8 76 -51 157 -96 l148 -81 80 -147 c44 -81 89 -152
100 -158 38 -21 61 4 145 157 l82 149 146 80 c218 118 218 126 3 246 l-152 84
-77 140 c-42 77 -82 146 -88 153 -13 13 -49 16 -68 4z"/>
            </g>
        </svg>

    )
}

AiSvg.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    fill: PropTypes.string,
}

export default AiSvg



